import _ from 'lodash';

// Use -FT postfix for all BE FeatureFlags
export const FeatureFlag = Object.entries({
  BuiltExpressionTreeField: 'builtExpressionTreeField',
  ChangeDomainName: 'changeDomainName',
  EnableNoiSend: 'enableNoiSend',
  DynamicFieldDefaultValues: 'dynamicFieldDefaultValues',
  PreviewFormBasedOnLoanId: 'previewFormBasedOnLoanId',
  LoanEditorAddOrDeleteCoBorrowerAction: 'LoanEditorAddOrDeleteCoBorrowerAction',
  HideSignatureLoanOfficerFormFields: 'HideSignatureLoanOfficerFormFields',
  OldTaskAssignmentEngine: 'Enable-Old-Task-Assignment-Engine-FT',
  MilitaryAddressToStates: 'MilitaryAddressToStates-FT',
  NonCashOutLiability: 'NonCashOutLiability-FT',
  HideLoanSpecificForm: 'HideLoanSpecificForm-26142-FT',
  EnableCubePlayground: 'EnableCubePlayground-25225-FT',
  EnablePurchaseLoans: 'EnablePurchaseLoans-FT',
  EnableQualificationDetails: 'EnableQualificationDetails-27173-FT',
  HideLoanHeaderViews: 'HideLoanHeaderViews-28124-FT',
  EnableCubeRequestHistory: 'EnableCubeRequestHistory_26660-FT',
  MiCoveragePercentages: 'MiCoveragePercentages-30108-FT',
  EnableToleranceType: 'EnableToleranceType-30997-FT',
  HideEscrowRequirementsChangesMessage: 'HideEscrowRequirementsChangesMessage-35346-FT',
  EnableLeSectionSelectionRestrictions: 'EnableLeSectionSelectionRestrictions-34016-FT',
  EnableBrokerProgramSuggestion: 'EnableBrokerProgramSuggestion-FT',
  EnableBrokerPricingWorkbench: 'EnableBrokerPricingWorkbench-34599-FT',
  EnableAppraisalFee: 'Enable-Appraisal-Fee-31680-FT',
  EnablePaymentTab: 'Enable-Payment-Tab-35599-FT',
  EnableCallConfirmation: 'EnableCallConfirmation-35144-FT',
  EnableCacheClearing: 'Enable-Cache-Clearing-36156-FT',
  EnablePreApproval: 'EnablePreApproval_36180-FT',
  EnableBrokerPricingWorkbenchLoanOptions: 'EnableBrokerPricingWorkbenchLoanOptions-38714-FT',
  EnableAppraisalProductCriteria: 'AppraisalProductCriteria-42385-FT',
  EnableUnderwritingEcd: 'EnableUnderwritingEcd-35676-FT',
  EnableLightWeightEmailBody: 'EnableLightWeightEmailBody-44992-FT',
  EnableTexasLoansCalculation: 'EnableTexasLoansCalculation-45822-FT',
  EnableFutureMilestonesCandidates: 'FutureMilestonesCandidates-44935-FT',
  EnableRestrictStateChangedForRegularLoan: 'RestrictStateChangedForRegularLoan-46761-FT',
  EnableFeeProviderPaidToType: 'FeeProviderPaidToType-47344-FT',
  EnableBrokerConditionTaskAssignment: 'EnableBrokerConditionTaskAssignment-48056-FT',
  EnableLockInfoPpeFields: 'LockInfoPpeFields-47939-FT',
  EnableApplicationInvestorFeatureCodes: 'EnableApplicationInvestorFeatureCodes-47997-FT',
  IsTestModeForTemplateCompanyOff: 'IsTestModeForTemplateCompanyOff-48328-FT',
  EnableLoanContactsOnPresentation: 'UseLoanContactsOnPresentation-48507-FT',
  EnableLoanContactsOnPresentationRealtors: 'UseLoanContactsOnPresentationRealtors-48509-FT',
  TurnOnCoPilot: 'TurnOnCoPilot-14328-FT',
  EnableSourceOfGrant: 'EnableSourceOfGrant-49893-FT',
  EnableLienPriority: 'EnableLienPriority-49951-FT',
  EnableSecondMortgageFlowSettings: 'EnableSecondMortgageFlowSettings-50927-FT',
  ShowInitialLeCurePopupColumn: 'ShowInitialLeCurePopupColumn-443-FT',
  UseTransferredFeeProviderCategory: 'UseTransferredFeeProviderCategory-422-FT',
  UseTransferredLodeStarFeeType: 'UseTransferredLodeStarFeeType-424-FT',
  EnableAsyncFileRequest: 'AsyncFileRequestEnabled-HZ-861-FT',
  ShowNewAlertsPage: 'NewAlertsPage-718-FT',
  EnablePartialPendingChanges: 'EnablePartialPendingChanges-HZ-934-FT',
  EnableSavePendingChangesLoanAction: 'SavePendingChangesAsLoanAction-HZ-2009-FT',
  PendingChangesByUser: 'PendingChangesByUser-FH-3040-FT',
  ParOnlySettingIsEnabled: 'ParOnlySettingIsEnabled-FZ-1484-FT',
  EnableMismoFeeTypeMapping: 'EnableMismoFeeTypeMapping-FZ-1403-FT',
  EnableAusPendingChanges: 'EnableAusPendingChanges-FZ-1457-FT',
  EnableMergeCureBaselines: 'MergeCureBaselines-FZ-1662-FT',
  EnableStraightforwardCicReason: 'EnableStraightforwardCicReason-FZ-1564-FT',
  EnableManageCicHistory: 'EnableManageCICHistory-FZ-1694-FT',
  EnablePrismFormEditor: 'EnablePrismFormEditor-HZ-1602-FT',
  EnablePrismPagelessEditor: 'EnablePrismPagelessEditor-FH-3867-FT',
  EnableExternalLoanLock: 'EnableExternalLoanLock-FZ-1704-FT',
  EnableNewExpressionsParsingLogic: 'NewExpressionsSyntaxParsingLogic-FZ-1980-FT',
  DisableOmittedFalsyValidationErrors: 'DisableOmittedFalsyValidationErrors-FZ-2232-FT',
  EnableLoadPricingStatusConfigurationsByIncludes:
    'LoadPricingStatusConfigurationsByIncludes-FZ-2177-FT',
  EnableRequestDeduplication: 'EnableRequestDeduplication-FZ-2357-FT',
  EnableChartPropertyAndLoan: 'EnableChartPropertyAndLoan-1934-FT',
  DisableFullChecklistRegeneration: 'DisableFullChecklistRegeneration-HZ-2158-FT',
  EnableRestyledUnderwritingTab: 'EnableRestyledUnderwritingTab-HZ-2875-FT',
  DisableLegacyUnderwritingTab: 'DisableLegacyUnderwritingTab-HZ-2875-FT',
  EnableCrm: 'EnableCrm-FT',
  EnableNotificationDispatcher: 'EnableNotificationDispatcher-FT',
  EnableNewProgramMapping: 'EnableNewProgramMapping-FZ-3435-FT',
  EnableNotificationCenter: 'EnableNotificationCenter-FT',
  EnableLazyLoadPricing: 'EnableLazyLoadPricing-FZ-3370-FT',
  EnableUploadDocumentsToNewTasks: 'EnableUploadDocumentsToNewTasks-HZ-3142-FT',
  DeduplicateRemoteLoanOptionsOnGroups: 'DeduplicateRemoteLoanOptionsOnGroups-FZ-3793-FT',
  EnableDynamicFieldBackgroundColor: 'EnableDynamicFieldBackgroundColor_FZ-3848-FT',
  EnableVendorRequestsTab: 'EnableVendorRequestsTab-HZ-3387-FT',
  EnableConstructionCore: 'EnableConstructionCore-DEV-4771-FT',
  EnableFormLocalOverrides: 'OverrideEnabled-HZ-3275-FT',
  SelfServeCustomDomains: 'selfServeCustomDomains-FT',
  EnableExpiredPricingSave: 'EnableExpiredPricingSave_FZ-4515-FT',
  EnableMortgageInsuranceFields: 'EnableMortgageInsuranceFields-FH-1224-FT',
  FormsConsolidationEnabled: 'FormsConsolidationEnabled-FT',
  ReadChecklistsFromFlatStore: 'ReadChecklistResultsFromFlatStore-FH-1829-FT',
  EnableAppraisalOrderContacts: 'EnableAppraisalOrderContacts-LEN2-307-FT',
  EnableAppraisalOrderOtherContacts: 'EnableAppraisalOrderOtherContacts-LEN2-307-FT',
}).reduce((acc, [key, value]) => {
  acc[key] = _.camelCase(value);

  return acc;
}, {});

// FeatureFlags that works locally only! Do not add here BE feature flags
export const localFeatureFlags = {
  [FeatureFlag.BuiltExpressionTreeField]: false,
  [FeatureFlag.ChangeDomainName]: false,
  [FeatureFlag.EnableNoiSend]: false,
  [FeatureFlag.DynamicFieldDefaultValues]: false,
  [FeatureFlag.PreviewFormBasedOnLoanId]: false,
  [FeatureFlag.LoanEditorAddOrDeleteCoBorrowerAction]: false,
  [FeatureFlag.HideSignatureLoanOfficerFormFields]: false,
  [FeatureFlag.ReadChecklistsFromFlatStore]: false,
};

export const adapterArgs = {
  clientSideId: '',
  user: { key: '' },
};
